module.exports = __webpack_public_path__ + "static/media/shape2_3.af4afb3f.obj";